export default __webpack_public_path__ + "static/media/landing-mobile-03.51245536.png";